module.exports = __webpack_public_path__ + "img/interview_icon.89ecf4c0.svg";